module.exports = __webpack_public_path__ + "static/media/icn_accordion_down_grey.d13448f3.svg";